const initialState = null;

export const associationPages = (state = initialState, action) => state;
export const associationPage = (state = initialState, action) => state;
